import { render, staticRenderFns } from "./OpenEndedMasonry.vue?vue&type=template&id=c649e836&scoped=true&"
import script from "./OpenEndedMasonry.vue?vue&type=script&lang=js&"
export * from "./OpenEndedMasonry.vue?vue&type=script&lang=js&"
import style0 from "./OpenEndedMasonry.vue?vue&type=style&index=0&id=c649e836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c649e836",
  null
  
)

export default component.exports